/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './photo-block.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory';
import * as i3 from '@angular/material/core';
import * as i4 from '@angular/material/button';
import * as i5 from '@angular/cdk/platform';
import * as i6 from '@angular/cdk/a11y';
import * as i7 from '@ngx-translate/core/src/translate.pipe';
import * as i8 from '@ngx-translate/core/src/translate.service';
import * as i9 from '@angular/common';
import * as i10 from '../../../../../$$_gendir/node_modules/@angular/material/progress-spinner/typings/index.ngfactory';
import * as i11 from '@angular/material/progress-spinner';
import * as i12 from '../../../../../app/shared/directives/has-permission/has-permission.directive';
import * as i13 from '../../../../../app/profile/profile.service';
import * as i14 from '../../../../../app/shared/components/photo-block/photo-block.component';
import * as i15 from '../../../../../app/shared/media/media.service';
import * as i16 from '../../../../../app/app-loader/config-loader.service';
const styles_PhotoBlockComponent:any[] = [i0.styles];
export const RenderType_PhotoBlockComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PhotoBlockComponent,data:{}});
function View_PhotoBlockComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'img',[['alt',
      'photo'],['class','organization-defaut-photo']],[[8,'src',4]],(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.mediaUrl;
    _ck(_v,0,0,currVal_0);
  });
}
function View_PhotoBlockComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'img',[['alt',
      'photo'],['class','organization-image'],['src','../../../../assets/images/image.png']],
      (null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),
      (null as any));
}
function View_PhotoBlockComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',[['class',
      'delete-button mat-raised-button'],['color','red'],['mat-raised-button',''],
      ['type','submit']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.onDeleteMedia()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MatButton_0,i2.RenderType_MatButton)),i1.ɵdid(16384,(null as any),0,i3.MatPrefixRejector,
      ([] as any[]),(null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i4.MatButton,
      [i1.Renderer2,i1.ElementRef,i5.Platform,i6.FocusMonitor],{color:[0,'color']},
      (null as any)),i1.ɵdid(16384,(null as any),0,i4.MatRaisedButtonCssMatStyler,
      ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵpid(131072,
      i7.TranslatePipe,[i8.TranslateService,i1.ChangeDetectorRef])],(_ck,_v) => {
    const currVal_1:any = 'red';
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = i1.ɵunv(_v,4,0,i1.ɵnov(_v,5).transform('DELETE'));
    _ck(_v,4,0,currVal_2);
  });
}
function View_PhotoBlockComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),13,'div',[['class',
      'organization-buttons']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,
      [['media',1]],(null as any),0,'input',[['accept','.jpg, .jpeg, .png'],['style',
          'display: none;'],['type','file']],(null as any),[[(null as any),'change']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.onChangeMedia($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'button',[['class','edit-button mat-raised-button'],
          ['mat-raised-button',''],['type','submit']],[[4,'background-color',(null as any)],
          [8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).click()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MatButton_0,i2.RenderType_MatButton)),i1.ɵdid(16384,(null as any),
          0,i3.MatPrefixRejector,([] as any[]),(null as any),(null as any)),i1.ɵdid(180224,
          (null as any),0,i4.MatButton,[i1.Renderer2,i1.ElementRef,i5.Platform,i6.FocusMonitor],
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i4.MatRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵpid(131072,
          i7.TranslatePipe,[i8.TranslateService,i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_PhotoBlockComponent_4)),i1.ɵdid(16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_3:any = (_co.photoFormControl.value !== (null as any));
    _ck(_v,12,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.platformConfig.platform.callcenterAppColor;
    const currVal_1:any = (i1.ɵnov(_v,6).disabled || (null as any));
    _ck(_v,4,0,currVal_0,currVal_1);
    const currVal_2:any = i1.ɵunv(_v,8,0,i1.ɵnov(_v,9).transform('EDIT'));
    _ck(_v,8,0,currVal_2);
  });
}
function View_PhotoBlockComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'spinner-content']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),1,'mat-progress-spinner',[['class','mat-progress-spinner'],
          ['mode','indeterminate'],['role','progressbar']],[[4,'width','px'],[4,'height',
          'px'],[1,'aria-valuemin',0],[1,'aria-valuemax',0],[1,'aria-valuenow',0],
          [1,'mode',0]],(null as any),(null as any),i10.View_MatProgressSpinner_0,
      i10.RenderType_MatProgressSpinner)),i1.ɵdid(573440,(null as any),0,i11.MatProgressSpinner,
      [i1.Renderer2,i1.ElementRef,i5.Platform,[2,i9.DOCUMENT]],{diameter:[0,'diameter'],
          strokeWidth:[1,'strokeWidth'],mode:[2,'mode']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n  ']))],(_ck,_v) => {
    const currVal_6:any = 55;
    const currVal_7:any = 5;
    const currVal_8:any = 'indeterminate';
    _ck(_v,3,0,currVal_6,currVal_7,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3)._elementSize;
    const currVal_1:any = i1.ɵnov(_v,3)._elementSize;
    const currVal_2:any = ((i1.ɵnov(_v,3).mode === 'determinate')? 0: (null as any));
    const currVal_3:any = ((i1.ɵnov(_v,3).mode === 'determinate')? 100: (null as any));
    const currVal_4:any = i1.ɵnov(_v,3).value;
    const currVal_5:any = i1.ɵnov(_v,3).mode;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  });
}
export function View_PhotoBlockComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),16,'div',[['class',
      'photo-container']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_PhotoBlockComponent_1)),i1.ɵdid(16384,
      (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_PhotoBlockComponent_2)),i1.ɵdid(16384,
      (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n\n \n  '])),(_l()(),i1.ɵeld(0,
      (null as any),(null as any),4,'div',[['class','organization-buttons-content']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_PhotoBlockComponent_3)),i1.ɵdid(16384,(null as any),0,i12.HasPermissionDirective,
      [i1.TemplateRef,i1.ViewContainerRef,i13.ProfileService],{appHasPermission:[0,
          'appHasPermission']},(null as any)),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_PhotoBlockComponent_5)),i1.ɵdid(16384,
          (null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i14.PhotoBlockComponent = _v.component;
    const currVal_0:any = (_co.mediaUrl !== (null as any));
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = (_co.mediaUrl === (null as any));
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = 'CLK-MEDIA-POST';
    _ck(_v,11,0,currVal_2);
    const currVal_3:any = _co.mediaLoading;
    _ck(_v,15,0,currVal_3);
  },(null as any));
}
export function View_PhotoBlockComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-photo-block',
      ([] as any[]),(null as any),(null as any),(null as any),View_PhotoBlockComponent_0,
      RenderType_PhotoBlockComponent)),i1.ɵdid(114688,(null as any),0,i14.PhotoBlockComponent,
      [i15.MediaService,i16.ConfigLoaderService],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PhotoBlockComponentNgFactory:i1.ComponentFactory<i14.PhotoBlockComponent> = i1.ɵccf('app-photo-block',
    i14.PhotoBlockComponent,View_PhotoBlockComponent_Host_0,{photoFormControl:'photoFormControl',
        placeholder:'placeholder'},{onMediaSelected:'onMediaSelected'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/photo-block/photo-block.component.ngfactory.ts